/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './photo-block.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory';
import * as i3 from '@angular/material/core';
import * as i4 from '@angular/material/button';
import * as i5 from '@angular/cdk/platform';
import * as i6 from '@angular/cdk/a11y';
import * as i7 from '@ngx-translate/core/src/translate.pipe';
import * as i8 from '@ngx-translate/core/src/translate.service';
import * as i9 from '@angular/common';
import * as i10 from '../../../../../$$_gendir/node_modules/@angular/material/progress-spinner/typings/index.ngfactory';
import * as i11 from '@angular/material/progress-spinner';
import * as i12 from '../../../../../app/shared/directives/has-permission/has-permission.directive';
import * as i13 from '../../../../../app/profile/profile.service';
import * as i14 from '../../../../../app/shared/components/photo-block/photo-block.component';
import * as i15 from '../../../../../app/shared/media/media.service';
import * as i16 from '../../../../../app/app-loader/config-loader.service';
const styles_PhotoBlockComponent:any[] = [i0.styles];
export const RenderType_PhotoBlockComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PhotoBlockComponent,data:{}});
function View_PhotoBlockComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'img',[['alt',
      'photo'],['class','organization-defaut-photo']],[[8,'src',4]],(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.mediaUrl;
    _ck(_v,0,0,currVal_0);
  });
}
function View_PhotoBlockComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'img',[['alt',
      'photo'],['class','organization-image'],['src','../../../../assets/images/image.png']],
      (null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),
      (null as any));
}
function View_PhotoBlockComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',[['class',
      'delete-button mat-raised-button'],['color','red'],['mat-raised-button',''],
      ['type','submit']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onDeleteMedia()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MatButton_0,i2.RenderType_MatButton)),i1.ɵdid(16384,(null as any),0,i3.MatPrefixRejector,
      ([] as any[]),(null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i4.MatButton,
      [i1.Renderer2,i1.ElementRef,i5.Platform,i6.FocusMonitor],{color:[0,'color']},
      (null as any)),i1.ɵdid(16384,(null as any),0,i4.MatRaisedButtonCssMatStyler,
      ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵpid(131072,
      i7.TranslatePipe,[i8.TranslateService,i1.ChangeDetectorRef])],(_ck,_v) => {
    const currVal_1:any = 'red';
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = i1.ɵunv(_v,4,0,i1.ɵnov(_v,5).transform('DELETE'));
    _ck(_v,4,0,currVal_2);
  });
}
function View_PhotoBlockComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',[['class',
      'organization-buttons']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,
      [['media',1]],(null as any),0,'input',[['accept','.jpg, .jpeg, .png'],['style',
          'display: none;'],['type','file']],(null as any),[[(null as any),'change']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.onChangeMedia($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',[['class','edit-button mat-raised-button'],
          ['mat-raised-button',''],['type','submit']],[[4,'background-color',(null as any)],
          [8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).click()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MatButton_0,i2.RenderType_MatButton)),i1.ɵdid(16384,(null as any),
          0,i3.MatPrefixRejector,([] as any[]),(null as any),(null as any)),i1.ɵdid(180224,
          (null as any),0,i4.MatButton,[i1.Renderer2,i1.ElementRef,i5.Platform,i6.FocusMonitor],
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i4.MatRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵpid(131072,
          i7.TranslatePipe,[i8.TranslateService,i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_PhotoBlockComponent_4)),i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = (_co.photoFormControl.value !== (null as any));
    _ck(_v,12,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.platformConfig.platform.callcenterAppColor;
    const currVal_1:any = (i1.ɵnov(_v,6).disabled || (null as any));
    _ck(_v,4,0,currVal_0,currVal_1);
    const currVal_2:any = i1.ɵunv(_v,8,0,i1.ɵnov(_v,9).transform('EDIT'));
    _ck(_v,8,0,currVal_2);
  });
}
function View_PhotoBlockComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'spinner-content']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'mat-progress-spinner',[['class','mat-progress-spinner'],
          ['mode','indeterminate'],['role','progressbar']],[[4,'width','px'],[4,'height',
          'px'],[1,'aria-valuemin',0],[1,'aria-valuemax',0],[1,'aria-valuenow',0],
          [1,'mode',0]],(null as any),(null as any),i10.View_MatProgressSpinner_0,
      i10.RenderType_MatProgressSpinner)),i1.ɵdid(573440,(null as any),0,i11.MatProgressSpinner,
      [i1.Renderer2,i1.ElementRef,i5.Platform,[2,i9.DOCUMENT]],{diameter:[0,'diameter'],
          strokeWidth:[1,'strokeWidth'],mode:[2,'mode']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n  ']))],(_ck,_v) => {
    const currVal_6:any = 55;
    const currVal_7:any = 5;
    const currVal_8:any = 'indeterminate';
    _ck(_v,3,0,currVal_6,currVal_7,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3)._elementSize;
    const currVal_1:any = i1.ɵnov(_v,3)._elementSize;
    const currVal_2:any = ((i1.ɵnov(_v,3).mode === 'determinate')? 0: (null as any));
    const currVal_3:any = ((i1.ɵnov(_v,3).mode === 'determinate')? 100: (null as any));
    const currVal_4:any = i1.ɵnov(_v,3).value;
    const currVal_5:any = i1.ɵnov(_v,3).mode;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  });
}
export function View_PhotoBlockComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),16,'div',[['class',
      'photo-container']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_PhotoBlockComponent_1)),i1.ɵdid(16384,
      (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_PhotoBlockComponent_2)),i1.ɵdid(16384,
      (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n\n \n  '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),4,'div',[['class','organization-buttons-content']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_PhotoBlockComponent_3)),i1.ɵdid(16384,(null as any),0,i12.HasPermissionDirective,
      [i1.TemplateRef,i1.ViewContainerRef,i13.ProfileService],{appHasPermission:[0,
          'appHasPermission']},(null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PhotoBlockComponent_5)),i1.ɵdid(16384,
          (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i14.PhotoBlockComponent = _v.component;
    const currVal_0:any = (_co.mediaUrl !== (null as any));
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = (_co.mediaUrl === (null as any));
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = 'CLK-MEDIA-POST';
    _ck(_v,11,0,currVal_2);
    const currVal_3:any = _co.mediaLoading;
    _ck(_v,15,0,currVal_3);
  },(null as any));
}
export function View_PhotoBlockComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-photo-block',
      ([] as any[]),(null as any),(null as any),(null as any),View_PhotoBlockComponent_0,
      RenderType_PhotoBlockComponent)),i1.ɵdid(114688,(null as any),0,i14.PhotoBlockComponent,
      [i15.MediaService,i16.ConfigLoaderService],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PhotoBlockComponentNgFactory:i1.ComponentFactory<i14.PhotoBlockComponent> = i1.ɵccf('app-photo-block',
    i14.PhotoBlockComponent,View_PhotoBlockComponent_Host_0,{photoFormControl:'photoFormControl',
        placeholder:'placeholder'},{onMediaSelected:'onMediaSelected'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/photo-block/photo-block.component.ngfactory.ts